<div class="modol_comp">
    <div class="modal-header pb-0 pt-0">
        <div>
            <button class="button-close" mat-button [mat-dialog-close]="false">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"/>
                </svg>
            </button>
        </div>
    </div>
    <div class="modal-body pt-0">
        <h2>  {{data?.heading }}</h2>
        <form class="" [formGroup]="serviceForm" >
            <div class="row">
                
                <div class="form-group col-md-12">
                    <label class="">Industry Name</label>
                    <input type="text" class="form-control mt-3" formControlName="serviceName" [maxlength]="maxLength.serviceName" [ngClass]="{ 'is-invalid': submitted && f['serviceName'].errors}"   placeholder="Enter Industry name" />
                    <div *ngIf=" submitted && f['serviceName'].errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['serviceName'].errors['required']">{{validationErrorMessage.serviceName}}</div>
                    </div>
                </div>
          
                </div>
            </form>
        </div>
    <div class="modal-footer d-flex justify-content-between">
        <button type="button" class="btn cancel" [mat-dialog-close]="false">Cancel</button>
        <button type="submit" class="btn delete" (click)="addService()">{{this.data.type == 1? 'Create Industry' : 'Save Changes'}}</button>
    </div>

</div>
